import { createApi } from '@stilingue/st-auth-utils';
import Service from './Service';
import { error401Handler } from '@/utils/error';

const gateway = process.env.VUE_APP_SERVICES_PROXY_URL || '';

const afterParser = (response) => {
  return response.data;
};

class OperatorsLogsService extends Service {
  constructor(gateway) {
    const api = createApi('/operators-logs/', gateway, {
      authNotFound: () => true,
      error401Handler,
    });

    super(api, {
      afterParser,
      retriesLimit: 10,
    });

    this.api.http.defaults.timeout = 600000;
  }

  getOperatorsLogs(params) {
    return this.find({
      ...params,
      url: 'operators-table',
    });
  }

  getOptions(params) {
    return this.find({
      ...params,
      url: 'get-options',
    });
  }

  getStatusChange(params) {
    return this.find({
      ...params,
      url: 'status-change',
    });
  }

  getSLA(params) {
    return this.find({
      ...params,
      url: 'sla',
    });
  }
}

export default new OperatorsLogsService(gateway);
